const OPEN_CLASS = "show";

function initHeader(header: HTMLElement): void {
    const panel = header.querySelector<HTMLElement>(".offcanvas");
    const toggler = header.querySelector<HTMLButtonElement>(".navbar-toggler");
    const closeButton = header.querySelector<HTMLButtonElement>(".btn-close");
    const nav = header.querySelector<HTMLElement>(".navbar");

    if (!panel || !toggler || !nav) {
        return;
    }

    let backdrop: HTMLElement | null = null;

    const close = (): void => {
        panel.classList.remove(OPEN_CLASS);
        toggler.setAttribute("aria-expanded", "false");
        backdrop?.remove();
        backdrop = null;
        toggler.focus();
    };

    const open = (): void => {
        panel.classList.add(OPEN_CLASS);
        toggler.setAttribute("aria-expanded", "true");

        backdrop = document.createElement("div");
        backdrop.className = "offcanvas-backdrop fade show d-lg-none";
        backdrop.addEventListener("click", close);
        nav.appendChild(backdrop);

        closeButton?.focus();
    };

    toggler.addEventListener("click", open);
    closeButton?.addEventListener("click", close);

    // Stäng menyn när en navlänk aktiveras eller vid Escape.
    panel.addEventListener("click", (event) => {
        const target = event.target as HTMLElement;
        if (target.closest("a, .breaks-btn")) {
            close();
        }
    });

    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && panel.classList.contains(OPEN_CLASS)) {
            close();
        }
    });
}

export function initHeaders(): void {
    document
        .querySelectorAll<HTMLElement>(".site-header")
        .forEach((header) => initHeader(header));
}

export default initHeaders;
